var SidebarVariant;
(function (SidebarVariant) {
    SidebarVariant["dynamic"] = "dynamic";
    SidebarVariant["static"] = "static";
})(SidebarVariant || (SidebarVariant = {}));
var SidebarItemSize;
(function (SidebarItemSize) {
    SidebarItemSize["tight"] = "tight";
    SidebarItemSize["wide"] = "wide";
})(SidebarItemSize || (SidebarItemSize = {}));
var SidebarSize;
(function (SidebarSize) {
    SidebarSize["tight"] = "tight";
    SidebarSize["wide"] = "wide";
})(SidebarSize || (SidebarSize = {}));
var SidebarContextKey = 'SidebarContext';

export { SidebarContextKey, SidebarItemSize, SidebarSize, SidebarVariant };
